module.exports = __webpack_public_path__ + "img/3x.7651f36.jpg";